var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fdef1556f527bab7565c1338e6d5c342ec800acb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["home-waste-web@clearabee"]={id:"fdef1556f527bab7565c1338e6d5c342ec800acb"};
      